import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setRoute('intrastat_declaration_list');
